export default {
    categories: {
        orderSaveFailed: 'Nie udało się zapisać kolejności.',
        name: 'Nazwa',
        namePlaceholder: 'np. Nabiał',
        newTitle: 'Nowa kategoria sklepowa',
        edit: 'Edytuj kategorię',
        delete: 'Usuń kategorię',
        deleteProducts: '{n} produkt zostanie bez kategorii. | {n} produkty zostaną bez kategorii. | {n} produktów zostanie bez kategorii.',
        cannotUndo: 'Tego nie da się cofnąć.',
        title: 'Kategorie sklepowe',
        count: '{n} kategoria | {n} kategorie | {n} kategorii',
        add: 'Dodaj kategorię',
        orderHint: 'Kolejność ustala trasę po sklepie — przeciągnij, żeby ją zmienić.',
        drag: 'Przeciągnij, aby zmienić kolejność',
        productsInCategory: '{n} produkt w tej kategorii | {n} produkty w tej kategorii | {n} produktów w tej kategorii',
        withoutCategory: '{n} produkt jest bez kategorii — w koszyku trafią do „Bez kategorii". | {n} produkty są bez kategorii — w koszyku trafią do „Bez kategorii". | {n} produktów jest bez kategorii — w koszyku trafią do „Bez kategorii".',
        position: 'pozycja {n}',
        productsTitle: 'PRODUKTY · {n}',
        inMeals: 'w {n} posiłku | w {n} posiłkach | w {n} posiłkach',
        noProducts: 'Żaden produkt nie ma jeszcze tej kategorii. Przypiszesz ją w oknie produktu.',
        mealsTitle: 'POSIŁKI Z TYMI PRODUKTAMI · {n}',
        noMeals: 'Żaden posiłek nie używa produktów z tej kategorii.',
        emptyTitle: 'Brak kategorii sklepowych',
        emptyText: 'Kategorie grupują koszyk w trybie zakupów i porządkują listę według półek.',
        deleteConfirm: 'Usunąć kategorię sklepową?',
    },
    list: {
        addProductFailed: 'Nie udało się dodać produktu.',
        unknownProduct: 'Nieznany produkt',
        item: 'Pozycja',
        servings: '{n} porcja | {n} porcje | {n} porcji',
        source: {
            meal: 'posiłek',
            semi: 'półprodukt',
            product: 'produkt',
            custom: 'własne',
        },
        fields: {
            servings: 'Porcje',
            servingsEditHint: 'Wagi składników przeliczą się na tyle porcji',
            portionsEditHint: 'Ile × {portion} kupić',
            amount: 'Ilość',
            amountEditHint: 'Ile kupić',
            name: 'Nazwa',
            namePlaceholder: 'np. worki na śmieci',
            weight: 'Waga',
            weightHint: 'Opcjonalna',
            customName: 'Własna nazwa',
            orProduct: 'albo produkt',
            productPlaceholder: 'Szukaj w katalogu produktów',
            amountHint: 'Gramy albo porcje produktu — puste znaczy 100 g',
            orMeal: 'albo posiłek',
            servingsHint: 'Dla posiłku — puste znaczy 1',
            orSemi: 'albo półprodukt',
            semiPortions: 'Porcje półproduktu',
            semiPortionsHint: 'Ile porcji kupić — puste znaczy 1',
        },
        addTitle: 'Dodaj do listy',
        editNamed: 'Edytuj „{name}”',
        editItem: 'Edytuj pozycję',
        bulk: {
            title: 'Wpisz wiele pozycji',
            label: 'Pozycje',
            placeholder: 'worki na śmieci\npasta do zębów\nżarówka E27',
            hint: 'Każda linijka zapisze się jako osobna pozycja.',
            partial: 'Dodano {added} z {total} — {failed} się nie zapisało.',
            added: 'Dodano {n} pozycję. | Dodano {n} pozycje. | Dodano {n} pozycji.',
        },
        clearConfirm: 'Wyczyścić całą listę?',
        removeSelectedConfirm: 'Usunąć {n} pozycję? | Usunąć {n} pozycje? | Usunąć {n} pozycji?',
        removeFailed: 'Nie udało się usunąć {n} pozycji. | Nie udało się usunąć {n} pozycji. | Nie udało się usunąć {n} pozycji.',
        noCategory: 'Bez kategorii',
        addedManually: 'Dopisane ręcznie',
        boughtCaps: 'KUPIONE',
        copyFailed: 'Przeglądarka nie pozwoliła skopiować listy.',
        title: 'Lista zakupowa',
        count: '{n} pozycja | {n} pozycje | {n} pozycji',
        addItem: 'Dodaj pozycję',
        filterLabel: 'Filtr kategorii sklepowej',
        allCategories: 'Wszystkie kategorie',
        searchCategories: 'Szukaj kategorii…',
        dictateTitle: 'Podyktuj, co kupić — produkty, półprodukty, posiłki i rzeczy spoza bazy',
        dictate: 'Podyktuj',
        bulkTitle: 'Wpisz wiele pozycji naraz — linijka po linijce',
        bulkButton: 'Wpisz wiele',
        showListTitle: 'Pokaż listę jako tekst do skopiowania',
        showList: 'Pokaż listę',
        shoppingModeTitle: 'Przejdź listę w sklepie',
        shoppingMode: 'Tryb zakupów',
        quickAdd: 'SZYBKIE DODAWANIE',
        deselectAll: 'Odznacz wszystkie',
        selectAll: 'Zaznacz wszystkie',
        selectedCount: '{n} zaznaczona | {n} zaznaczone | {n} zaznaczonych',
        total: 'Razem',
        removeSelected: 'Usuń zaznaczone',
        clear: 'Wyczyść listę',
        deselect: 'Odznacz',
        select: 'Zaznacz',
        collapseIngredients: 'Zwiń składniki',
        showIngredients: 'Pokaż składniki',
        changeServings: 'Zmień liczbę porcji',
        unmarkBought: 'Cofnij — jeszcze do kupienia',
        markBought: 'Oznacz jako kupione',
        removeFromList: 'Usuń z listy',
        semiComposition: 'SKŁAD PÓŁPRODUKTU',
        semiNoIngredients: 'Ten półprodukt nie ma zapisanych składników.',
        mealComposition: 'SKŁAD POSIŁKU',
        mealNoIngredients: 'Ten posiłek nie ma zapisanych składników.',
        emptyCategoryTitle: 'Nic w tej kategorii',
        emptyCategoryText: 'Kategoria sklepowa jest przypisana do produktu — pozycje własne, posiłki i półprodukty jej nie mają.',
        showAll: 'Pokaż wszystkie',
        emptyTitle: 'Lista zakupowa jest pusta',
        emptyText: 'Gdy lista będzie gotowa, tryb zakupów poprowadzi po sklepie kategoriami.',
        bulkManyAtOnce: 'Wpisz wiele naraz',
        removeConfirm: 'Usunąć z listy zakupowej?',
        clearConfirmText: 'Znikną wszystkie pozycje, także te dodane z posiłków i półproduktów. Tego nie da się cofnąć.',
        textTitle: 'Lista do kupienia',
        textEmpty: 'Koszyk jest pusty.',
        close: 'Zamknij',
        copied: 'Skopiowano',
        copy: 'Kopiuj',
    },
    stores: {
        andMore: '{names} i {n} inna | {names} i {n} inne | {names} i {n} innych',
        storeName: 'Nazwa sklepu',
        storeNamePlaceholder: 'np. Biedronka',
        newStore: 'Nowy sklep',
        editStore: 'Edytuj sklep',
        itemName: 'Nazwa',
        itemNamePlaceholder: 'np. mleko',
        store: 'Sklep',
        storeEditHint: 'Zmiana przeniesie pozycję z tego sklepu do wybranego — pozostałe przypisania zostają',
        storeNewHint: 'Jedna pozycja może być w wielu sklepach — dopisz ją w każdym',
        saveItemFailed: 'Nie udało się zapisać pozycji.',
        deleteItemFailed: 'Nie udało się usunąć pozycji.',
        addItemFailed: 'Nie udało się dodać pozycji.',
        subtitle: '{n} sklep · Twoja lista zakupów w jednym miejscu | {n} sklepy · Twoja lista zakupów w jednym miejscu | {n} sklepów · Twoja lista zakupów w jednym miejscu',
        productCount: '{n} produkt | {n} produkty | {n} produktów',
        title: 'Sklepy',
        searchLabel: 'Szukaj sklepu lub produktu',
        searchPlaceholder: 'Szukaj sklepu lub produktu…',
        filters: 'Sortowanie i filtry',
        sort: 'SORTUJ',
        sortName: 'Alfabetycznie',
        sortCount: 'Najwięcej produktów',
        hideEmpty: 'Ukryj puste sklepy',
        uncheckAll: 'Odznacz wszystko ({n})',
        removeBoughtTitle: 'Usuń z list sklepowych wszystkie odhaczone pozycje',
        removeBought: 'Usuń kupione ({n})',
        addStore: 'Dodaj sklep',
        boughtCount: '{n} kupione',
        more: 'Więcej',
        moreLabel: 'Więcej opcji sklepu',
        rename: 'Zmień nazwę',
        uncheckStore: 'Odznacz w tym sklepie',
        deleteStore: 'Usuń sklep',
        undo: 'Cofnij',
        also: 'też: {stores}',
        deleteItem: 'Usuń pozycję',
        noProducts: 'Brak produktów',
        noProductsHint: 'Dodaj pierwszy produkt do tej listy.',
        addProductTo: 'Dodaj produkt do: {name}',
        addProductPlaceholder: 'Dodaj produkt…',
        addProduct: 'Dodaj produkt',
        noMatch: 'Nic nie pasuje',
        noMatchText: 'Żaden sklep ani produkt nie pasuje do wyszukiwania.',
        emptyTitle: 'Brak sklepów',
        emptyText: 'Sklepy porządkują listę zakupową według miejsc.',
        deleteStoreConfirm: 'Usunąć sklep?',
        deleteStoreMessage: 'Pozycje przypisane tylko do niego stracą sklep.',
        newItem: 'Nowa pozycja',
        removeCheckedConfirm: 'Usunąć {n} zaznaczoną pozycję? | Usunąć {n} zaznaczone pozycje? | Usunąć {n} zaznaczonych pozycji?',
        removeCheckedMessage: 'Znikną ze wszystkich sklepów, w których są.',
        deleteItemConfirm: 'Usunąć pozycję?',
        deleteItemMessage: 'Zniknie ze wszystkich sklepów, w których była.',
    },
    mode: {
        left: '{left} do wzięcia z {all}',
        uncheckAll: 'Odznacz wszystko',
        finish: 'Zakończ',
        loading: 'Ładuję koszyk…',
        loadFailed: 'Nie udało się pobrać koszyka.',
        retry: 'Spróbuj ponownie',
        taken: '{name} · wzięte',
        emptyTitle: 'Koszyk jest pusty',
        emptyText: 'Dodaj coś do listy zakupowej, a pojawi się tutaj.',
    },
    review: {
        kind: {
            product: 'Produkt',
            semiProduct: 'Półprodukt',
            meal: 'Posiłek',
            newProduct: 'Nowy produkt',
            custom: 'Tylko nazwa',
        },
        servingsUnit: 'porcje',
        increased: '{name} +{amount}',
        increasedTotal: '{name} +{amount} (razem {total})',
        newProductNote: '(nowy produkt)',
        goneFromDb: 'Coś z listy zniknęło z bazy w międzyczasie — wybierz dopasowanie jeszcze raz.',
        addFailed: 'Nie udało się dodać pozycji — spróbuj ponownie.',
        nothingLeft: 'Nic nie zostało do dodania.',
        nameLabel: 'Nazwa: {text}',
        heard: '„{text}"',
        remove: 'Usuń z podglądu',
        optional: 'opcjonalnie',
        nameOnlyTitle: 'Bez produktu w bazie — np. rzeczy, które nie są jedzeniem',
        asNewTitle: 'Dodaj do bazy jako nowy produkt',
        asNew: 'Jako nowy produkt',
        onList: 'Już na liście: {amount}',
        addSeparately: 'Dodaj osobno',
        addToExisting: 'Dolicz do istniejącej',
        maybe: 'Może:',
        pickFromDb: 'Wybierz z bazy',
        searchPlaceholder: 'Szukaj produktu, półproduktu albo posiłku…',
        notFound: 'Nic takiego w bazie.',
        skip: 'Pomiń',
        addCount: 'Dodaj {n} pozycję | Dodaj {n} pozycje | Dodaj {n} pozycji',
    },
};
